import { useFormikContext } from 'formik'
import { useCallback, useContext } from 'react'
import { PatientFormFields } from './PatientForm.model'
import { ConnectedUserContext } from '../../../misc/auth.utilities'

export const useClearINSIStatusHook = () => {
  const formikContext = useFormikContext<PatientFormFields>()
  const { loggedUser } = useContext(ConnectedUserContext)
  return useCallback(() => {
    if (loggedUser) {
      formikContext.setFieldValue('identityStatus.insiStatus.checked', 'UNCHECKED')
      formikContext.setFieldValue('identityStatus.insiStatus.checkedAt', null)
      formikContext.setFieldValue('inseeNumber', '')
      formikContext.setFieldValue('assigningAuthority.oid', null)
      formikContext.setFieldValue('identityStatus.trustedSource', null)
      formikContext.setFieldValue('identityStatus.showTrustedSource', false)
    }
  }, [formikContext, loggedUser])
}
